module.exports = __webpack_public_path__ + "img/visualize_the_web_1.0af24925.png";